export default __webpack_public_path__ + "static/media/reciprocalhealing.fe52c3d9.png";